import React from 'react'
export const connect = React.createContext();
